// src/data.js
export const foodData = [
  /* ================= বিরিয়ানি ================= */
  { id: 1, name: "কাচ্চি বিরিয়ানি", price: 450, category: "বিরিয়ানি", image: "./kacchi.jpg" },
  { id: 2, name: "চিকেন বিরিয়ানি", price: 280, category: "বিরিয়ানি", image: "./chiken-biriyani.jpeg" },
  { id: 3, name: "হাড়ি বিরিয়ানি", price: 480, category: "বিরিয়ানি", image: "./biriyani.jpg" },
  { id: 4, name: "মাটন দম বিরিয়ানি", price: 520, category: "বিরিয়ানি", image: "./muttondom.jpg" },
  { id: 5, name: "সবজি বিরিয়ানি", price: 180, category: "বিরিয়ানি", image: "./sobji.jpg" },
  { id: 6, name: "মাশরুম বিরিয়ানি", price: 460, category: "বিরিয়ানি", image: "./masroom.jpg" },
  { id: 7, name: "মাটন বিরিয়ানি", price: 350, category: "বিরিয়ানি", image: "./mutton.jpg" },
  { id: 8, name: "ডিম বিরিয়ানি", price: 550, category: "বিরিয়ানি", image: "./egg.jpg" },
  { id: 9, name: "বোম্বে বিরিয়ানি", price: 400, category: "বিরিয়ানি", image: "./bombe.jpeg" },
  { id: 10, name: "আফগানি বিরিয়ানি", price: 490, category: "বিরিয়ানি", image: "./afgani.jpg" },
  { id: 11, name: "শাহি বিরিয়ানি", price: 180, category: "বিরিয়ানি", image: "./sahi.jpeg" },
  { id: 12, name: "কলকাতা চিকেন বিরিয়ানি", price: 380, category: "বিরিয়ানি", image: "./kolkata.jpg" },
  { id: 13, name: "রুই মাছের বিরিয়ানি", price: 420, category: "বিরিয়ানি", image: "./fish.jpg" },
  { id: 14, name: "মোরগ পোলাও", price: 300, category: "বিরিয়ানি", image: "./polaw.jpg" },
  { id: 15, name: "পনির বিরিয়ানি", price: 250, category: "বিরিয়ানি", image: "./ponir1.jpg" },
  { id: 16, name: "মালাবার চিকেন বিরিয়ানি", price: 600, category: "বিরিয়ানি", image: "./malbar.jpg" },
  { id: 17, name: "হারিয়ানা বিরিয়ানি", price: 470, category: "বিরিয়ানি", image: "./hari.jpg" },
  { id: 18, name: "বাটার চিকেন বিরিয়ানি", price: 220, category: "বিরিয়ানি", image: "./buttrt.jpg" },
  { id: 19, name: "কাকড়া বিরিয়ানি", price: 200, category: "বিরিয়ানি", image: "./kakra.jpg" },
  { id: 20, name: "প্রন (চিংড়ি) বিরিয়ানি", price: 580, category: "বিরিয়ানি", image: "./Prawn.jpg" },

  /* ================= মাছ ================= */
  { id: 21, name: "ইলিশ সর্ষে", price: 550, category: "মাছ", image: "./ilish.jpg" },
  { id: 22, name: "চিংড়ি ভুনা", price: 600, category: "মাছ", image: "./chingri-vuna.webp" },
  { id: 23, name: "চিংড়ি মালাই কারি", price: 600, category: "মাছ", image: "./malaikari.jpg" },
  { id: 24, name: "চিংড়ি ফ্রাই", price: 400, category: "মাছ", image: "./chingri-fry.jpg" },
  { id: 25, name: "রুই মাছ", price: 400, category: "মাছ", image: "./rui.jpg" },
  { id: 26, name: "ইলিশ ফ্রাই", price: 400, category: "মাছ", image: "./hilsa-fry.jpg" },
  { id: 27, name: "ইলিশ ভুনা", price: 400, category: "মাছ", image: "./hilsa-curry.jpg" },
  { id: 28, name: "কাতলা মাছের ঝোল", price: 400, category: "মাছ", image: "./katla.jpg" },
  { id: 29, name: "পাবদা মাছ ভাজা", price: 400, category: "মাছ", image: "./pabda.jpg" },
  { id: 30, name: "পোয়া মাছ", price: 20, category: "মাছ", image: "./poya.jpg" },

  /* ================= মাংস ================= */
  { id: 31, name: "চিকেন রোস্ট", price: 250, category: "মাংস", image: "./rost.avif" },
  { id: 32, name: "মাটন কারি", price: 500, category: "মাংস", image: "./mutton-curry.jpg" },
  { id: 33, name: "হাঁসের কালাভুনা", price: 420, category: "মাংস", image: "./duck.webp" },
  { id: 34, name: "চিলি চিকেন", price: 350, category: "মাংস", image: "./chilichicken.jpg" },
  { id: 35, name: "চিকেন তন্দুরি", price: 320, category: "মাংস", image: "./tandoori.jpg" },

  /* ================= কাবাব ================= */
  { id: 36, name: "চিকেন কাবাব", price: 200, category: "কাবাব", image: "./kabab.jpg" },
  { id: 37, name: "কাবাব রোল", price: 150, category: "কাবাব", image: "./kababroll.jpg" },
  { id: 38, name: "চিকেন রেশমি কাবাব", price: 280, category: "কাবাব", image: "./rasmikabab.jpg" },
  { id: 39, name: "শিক কাবাব", price: 320, category: "কাবাব", image: "./shik-kabab.avif" },
  { id: 40, name: "চিকেন টিক্কা কাবাব", price: 250, category: "কাবাব", image: "./tikka.jpg" },
  { id: 41, name: "মাটন গালৌতি কাবাব", price: 450, category: "কাবাব", image: "./galouti.webp" },

  /* ================= স্ন্যাকস / স্ট্রিট‑ফুড ================= */
  { id: 42, name: "ফুচকা স্পেশাল", price: 80, category: "স্ট্রিট‑ফুড", image: "./fuchka.jpg" },
  { id: 43, name: "সামুসা", price: 130, category: "স্ট্রিট‑ফুড", image: "./samosa.jpg" },
  { id: 44, name: "ফ্রাইড চিকেন বার্গার", price: 130, category: "স্ন্যাকস", image: "./burger-chiken.jpg" },
  { id: 45, name: "চিজ বার্গার", price: 130, category: "স্ন্যাকস", image: "./chisburger.jpg" },
  { id: 46, name: "চিকেন চিজ বার্গার", price: 130, category: "স্ন্যাকস", image: "./burger.avif" },
  { id: 47, name: "নুডলস", price: 130, category: "স্ট্রিট‑ফুড", image: "./noodles.avif" },
  { id: 48, name: "চিকেন নাগা বার্গার", price: 130, category: "স্ন্যাকস", image: "./bomb.avif" },
  { id: 49, name: "মোমো", price: 150, category: "স্ট্রিট‑ফুড", image: "./momo.jpg" },
  { id: 50, name: "লুচি আলুর দম", price: 150, category: "স্ট্রিট‑ফুড", image: "./luci.jpg" },
  { id: 51, name: "ফ্রেঞ্চ ফ্রাই", price: 150, category: "স্ন্যাকস", image: "./frenc-fry.avif" },
  { id: 52, name: "লুচি ডাল", price: 80, category: "স্ট্রিট‑ফুড", image: "./luci dal.jpg" },
  { id: 53, name: "চাউমিন", price: 80, category: "স্ট্রিট‑ফুড", image: "./chawmin.jpg" },
  { id: 54, name: "ডিম চপ", price: 80, category: "স্ট্রিট‑ফুড", image: "./dimchop.jpg" },
  { id: 55, name: "বেগুনি", price: 80, category: "স্ট্রিট‑ফুড", image: "./begun.jpg" },
  { id: 56, name: "ইফতার", price: 80, category: "স্ট্রিট‑ফুড", image: "./iftar.jpg" },
  { id: 57, name: "চানাচুর মাখা", price: 80, category: "স্ট্রিট‑ফুড", image: "./chanachur.avif" },
  { id: 58, name: "ঝাল মুড়ি", price: 80, category: "স্ট্রিট‑ফুড", image: "./jhal.jpg" },
  { id: 59, name: "পরোটা", price: 60, category: "স্ট্রিট‑ফুড", image: "./porota.jpg" },
  { id: 60, name: "পরোটার সাথে ৫ পদের তরকারি", price: 80, category: "স্ট্রিট‑ফুড", image: "./porotapoth.jpg" },

  /* ================= ডেজার্ট ================= */
  { id: 61, name: "স্পেশাল ফালুদা", price: 150, category: "ডেজার্ট", image: "./faluda.avif" },
  { id: 62, name: "মিষ্টি দই", price: 120, category: "ডেজার্ট", image: "./doi.jpg" },
  { id: 63, name: "রসগোল্লা", price: 200, category: "ডেজার্ট", image: "./rosgolla.jpg" },
  { id: 64, name: "পায়েস", price: 150, category: "ডেজার্ট", image: "./payesh.avif" },
  { id: 65, name: "টক দই", price: 150, category: "ডেজার্ট", image: "./tokdoi.jpg" },
  { id: 66, name: "পাটিসাপঠা পিঠা", price: 150, category: "ডেজার্ট", image: "./pitaa.jpg" },
  { id: 67, name: "ফিক্স ফুড", price: 180, category: "ডেজার্ট", image: "./mixfood.webp" },
  { id: 68, name: "বগুড়ার দই", price: 80, category: "ডেজার্ট", image: "./bogura.jpg" },

  /* ================= ড্রিংকস ================= */
  { id: 69, name: "বোরহানী", price: 60, category: "ড্রিংকস", image: "./borhani.jpg" },
  { id: 70, name: "লেমন জুস", price: 80, category: "ড্রিংকস", image: "./lemon.jpg" },
  { id: 71, name: "মাল্টা জুস", price: 80, category: "ড্রিংকস", image: "./orange.avif" },
  { id: 72, name: "লেমন মিন্ট জুস", price: 80, category: "ড্রিংকস", image: "./lemonmint.jpg" },
  { id: 73, name: "মিষ্টি লাচ্ছি", price: 90, category: "ড্রিংকস", image: "./lassi.jpeg" },
  { id: 74, name: "বিটরুট জুস", price: 120, category: "ড্রিংকস", image: "./bitrut.jpg" },
  { id: 75, name: "পুদিনা জুস", price: 120, category: "ড্রিংকস", image: "./pudinaa.webp" },
  { id: 76, name: "পিনাট জুস", price: 120, category: "ড্রিংকস", image: "./penut.jpg" },

  /* ================= চা-কফি ================= */
  { id: 77, name: "কোল্ড কফি", price: 120, category: "চা-কফি", image: "./coldcoffee.avif" },
  { id: 78, name: "মিল্ক কফি", price: 120, category: "চা-কফি", image: "./coldcoffe.jpg" },
  { id: 79, name: "কফি", price: 120, category: "চা-কফি", image: "./coffe.avif" },
  { id: 80, name: "দুধ চা", price: 120, category: "চা-কফি", image: "./cha.avif" },
  { id: 81, name: "মসলা চা", price: 120, category: "চা-কফি", image: "./mosla-cha.webp" },
  { id: 82, name: "মটকা চা", price: 120, category: "চা-কফি", image: "./motka-cha.webp" },
  { id: 83, name: "তন্দুরি চা", price: 20, category: "চা-কফি", image: "./tonduri.jpg" },

  /* ================= দেশি ================= */
  { id: 84, name: "চিকেন পোলাও", price: 150, category: "দেশি", image: "./polaw.jpg" },
  { id: 85, name: "ডিম সিদ্ধ", price: 30, category: "দেশি", image: "./egg1.jpg" },
  { id: 86, name: "ভাপা ইলিস", price: 150, category: "দেশি", image: "./vapa.jpg" },
  { id: 87, name: "ডাল", price: 120, category: "দেশি", image: "./dal.jpg" },
  { id: 88, name: "পান্তা ভাত", price: 150, category: "দেশি", image: "./panta.jpg" },
  { id: 89, name: "শিম ভর্তা", price: 50, category: "দেশি", image: "./sim.jpg" },
  { id: 90, name: "সজনে ডাটা", price: 30, category: "দেশি", image: "./sojne.jpg" },
  { id: 91, name: "ডিম ভাজি", price: 20, category: "দেশি", image: "./egg1.avif" },
  { id: 92, name: "ভাতের সাথে ১২ পদের তরকারি", price: 120, category: "দেশি", image: "./12poth.jpg" },
  { id: 93, name: "ভাতের সাথে ৭ পদের তরকারি", price: 120, category: "দেশি", image: "./6poth.avif" },
  { id: 94, name: "সবজি", price: 20, category: "দেশি", image: "./sobji.avif" },
];
